import {
  CustomLoadingOverlay,
  CustomLoadingOverlayParams,
} from '@/components/Shared/aggrid-custom-overlays/custom-loading-overlay'
import {
  CustomNoRowsOverlay,
  CustomNoRowsOverlayParams,
} from '@/components/Shared/aggrid-custom-overlays/custom-no-rows-overlay'
import {
  CellClassParams,
  ColDef,
  ColumnMenuTab,
  ValueFormatterParams,
} from '@ag-grid-community/core'

interface CustomColDef extends ColDef {
  children?: CustomColDef[]
}

export const defaultColDefs: ColDef = {
  sortable: true,
  filter: true,
  resizable: true,
  cellStyle: (cellParams: CellClassParams) =>
    updateCellStyleForNumericValues(cellParams),
}

export const reportDetailsDefaultColDef = {
  ...defaultColDefs,
  menuTabs: ['generalMenuTab', 'filterMenuTab'] as ColumnMenuTab[],
  enableRowGroup: true,
}

export const defaultGridOptions = {}

export const reportDefaultColDef = {
  ...defaultColDefs,
  suppressMovable: true,
  sortable: false,
  lockPosition: true,
  suppressHeaderMenuButton: true,
  cellStyle: (params: CellClassParams) =>
    updateCellStyleForNumericValues(params),
}

export const cellValueFormatter = (
  params: ValueFormatterParams,
  precisionNumber: number,
) => {
  if (
    (params.value || params.value === 0) &&
    typeof params.value !== 'string'
  ) {
    return params.value.toFixed(precisionNumber)
  }
  return params.value
}

export const addFormatterOnColumns = (
  columnsList: CustomColDef[],
  precisionNumber: number,
): CustomColDef[] => {
  return columnsList.map((column: CustomColDef) => {
    if (column.children) {
      column.children = addFormatterOnColumns(column.children, precisionNumber)
    } else {
      column.valueFormatter = (params: ValueFormatterParams) =>
        cellValueFormatter(params, precisionNumber)
      column.width = 100
    }
    return column
  })
}

export const updateCellStyleForNumericValues = (params: CellClassParams) => {
  if (typeof params.value === 'number' || typeof params.value === 'object') {
    return { textAlign: 'right' }
  }
  return { textAlign: 'left' }
}

export const defaultAgGridSidebarProps = {
  toolPanels: [
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivots: true,
        suppressPivotMode: true,
        suppressColumnExpandAll: true,
      },
    },
    {
      id: 'filters',
      labelDefault: 'Filters',
      labelKey: 'filters',
      iconKey: 'filter',
      toolPanel: 'agFiltersToolPanel',
    },
  ],
  hiddenByDefault: false,
}

export const portfolioOptimizationDefaultGridOptions = {
  sideBar: defaultAgGridSidebarProps,
  defaultColDef: {
    ...defaultColDefs,
    filter: 'agTextColumnFilter',
    menuTabs: ['generalMenuTab'] as ColumnMenuTab[],
    flex: 1,
    floatingFilter: true,
  },
  loadingOverlayComponent: CustomLoadingOverlay,
  loadingOverlayComponentParams: CustomLoadingOverlayParams,

  noRowsOverlayComponent: CustomNoRowsOverlay,
  noRowsOverlayComponentParams: CustomNoRowsOverlayParams,
}
